import React from 'react'
import { Grid, Link } from '@mui/material'

import { SbpRefundOperation } from '../../../types.ts'
import { DataBlock, Icon } from '../../../components'
import { REFUND_ADDITIONAL_INFO, REFUND_GENERAL_INFO } from '../constants.ts'

export const RefundOperationView = ({
  refund,
  handleBack,
}: {
  refund: SbpRefundOperation
  handleBack(): void
}): React.ReactElement => {
  return (
    <>
      <Link
        onClick={handleBack}
        color="text.primary"
        sx={({ typography }) => ({
          fontSize: typography.h5.fontSize,
          display: 'flex',
          alignItems: 'center',
          fontWeight: '500',
          cursor: 'pointer',
          mb: 3,
        })}
      >
        <Icon name="ArrowLeft" size="lg" colorScheme="text.primary" />К списку возвратов
      </Link>
      <Grid container flexDirection="row" spacing={{ xs: 2, lg: 4 }}>
        <Grid item xs={12} md={6}>
          <DataBlock items={REFUND_GENERAL_INFO} data={refund} />
        </Grid>
        <Grid item xs={12} md={6}>
          <DataBlock items={REFUND_ADDITIONAL_INFO} data={refund} />
        </Grid>
      </Grid>
    </>
  )
}
